/** English fallback for the WhatsApp integration; wired up in lib/i18n/en.ts. */
export const whatsAppTr = {
  qr: {
    contactMismatch: 'Telefon numarası seçilen müşteriye veya ilgili kişiye ait değil.',
    history: 'WhatsApp mesajı',
    accessDenied: 'WhatsApp bağlantısı bu sunucuda etkin değil veya yetkiniz yok.',
    sendFailed:
      'Mesajın gönderildiği kesin olarak doğrulanamadı. Tekrar göndermeden önce mesaj durumunu ve bağlantıyı kontrol edin.',
    documentCustomerMismatch: 'Belge bu sohbetin müşterisine ait değil.',
    templatesUnavailable: 'WhatsApp (Baileys) için Cloud şablonları kullanılamaz.',
    provider: 'WhatsApp (Baileys)',
    providerField: 'Bağlantı sağlayıcısı',
    cloudProvider: 'WhatsApp Business Cloud API',
    label: 'Baileys üzerinden resmî olmayan bağlantı',
    help: 'WhatsApp yardımı',
    setup:
      'WhatsApp hesabınızı QR ile bağlayın. Sohbet telefonda başlasa bile bilinen ERP kişilerine ait metinler görünür; yanıtlar ve bağlantı kesintisinde alınan mesajlar da aktarılır.',
    loadError: 'Bağlantı durumu yüklenemedi.',
    connect: 'Numarayı bağla',
    reconnect: 'Yeniden bağlan',
    logout: 'Oturumu kapat',
    qrAlt: 'WhatsApp bağlantısı için QR kodu',
    scan: 'Telefonunuzda WhatsApp → Bağlı cihazlar → Cihaz bağla yolunu açıp bu QR kodunu tarayın.',
    expires: 'QR kodunun geçerlilik süresi: {{time}}.',
    expired: 'QR kodunun süresi doldu. Yeni kod almak için yeniden bağlanın.',
    connectionError: 'Bağlantı kesildi veya kurulamadı. Yeniden bağlanarak tekrar deneyin.',
    actionError: 'İşlem başarısız oldu. Sunucu erişiminizi kontrol edip tekrar deneyin.',
    limits:
      'Tekil gönderim açık kullanıcı işlemi gerektirir. Özel sohbet geçmişi ve adres defteri içe aktarılmaz. Başlangıç modu, izinler ve iletişim engelleri geçerliliğini korur.',
    logoutTitle: 'WhatsApp numarasının oturumu kapatılsın mı?',
    logoutDescription:
      '{{phone}} bağlantısı kesilir ve kayıtlı oturum silinir. Yeni bağlantı için QR kodunun yeniden taranması gerekir.',
    logoutConfirm: 'Numaranın oturumunu kapat ve oturumu sil',
    pdfHint:
      'Belge WhatsApp (Baileys) üzerinden doğrudan PDF olarak gönderilir. Cloud şablonları ve 24 saatlik pencere burada uygulanmaz.',
    pdfSend: 'PDF’yi WhatsApp üzerinden gönder',
    accepted: 'Gönderim kabul edildi. Teslimat durumu gerçek WhatsApp olaylarına göre güncellenir.',
    status: {
      DISCONNECTED: 'Bağlı değil',
      CONNECTING: 'Bağlanıyor',
      QR_READY: 'QR kodu taranmaya hazır',
      CONNECTED: 'Bağlı',
      EXPIRED: 'QR kodunun süresi doldu',
      ERROR: 'Bağlantı hatası',
    },
  },
  inbox: {
    title: 'WhatsApp ekibi gelen kutusu',
    subtitle: 'Kullanılabilir WhatsApp bağlantısıyla müşteri mesajları ve PDF belgeleri.',
    search: 'Adı, numarayı veya mesajı arayın',
    empty: 'Bu görünümde konuşma yok.',
    error: 'Konuşmalar yüklenemedi.',
    selectHint: 'Soldan bir görüşme seçin.',
  },
  scope: {
    ALL: 'Hepsi',
    MINE: 'Maden',
    UNASSIGNED: 'Atanmamış',
    CLOSED: 'Kapalı',
  },
  conversationStatus: {
    OPEN: 'Aç',
    PENDING: 'Beklemede',
    RESOLVED: 'Çözüldü',
    ARCHIVED: 'Arşivlendi',
  },
  status: {
    PENDING: 'Gönderiliyor',
    SENT: 'Gönderildi',
    DELIVERED: 'Teslim edildi',
    READ: 'Oku',
    FAILED: 'Başarısız',
  },
  templateStatus: {
    APPROVED: 'Onaylandı',
    PENDING: 'İnceleniyor',
    REJECTED: 'Reddedildi',
    PAUSED: 'Duraklatıldı',
    DISABLED: 'Devre Dışı',
  },
  category: {
    MARKETING: 'Pazarlama',
    UTILITY: 'Yardımcı Program',
    AUTHENTICATION: 'Kimlik Doğrulaması',
  },
  optIn: {
    OPTED_IN: 'Kayıtlı onay',
    OPTED_OUT: 'İtiraz kaydedildi',
    PENDING: 'İstek beklemede',
    NOT_REQUESTED: 'Henüz talep edilmedi',
  },
  window: {
    open: 'Pencere açık · {{hours}} sa {{minutes}} dk.',
    openShort: 'Pencere açık ({{hours}} sa {{minutes}} dk.)',
    closed: 'Yalnızca şablonlar',
    closedShort: 'Pencere kapatıldı — yalnızca şablonlar',
  },
  chat: {
    unknownCustomer: 'Bağlantılı müşteri yok',
    openCustomer: 'Müşteri profili',
    assignee: 'Vekil',
    unassigned: 'Atanmamış',
    status: 'Durum',
    empty: 'Bu görüşmede henüz mesaj yok.',
    error: 'Mesaj geçmişi yüklenemedi.',
    placeholder: 'Bir mesaj yazın… (Enter gönderir, yeni satır için Shift+Enter)',
    send: 'Gönder',
    emoji: 'Emoji ekle',
    attachDocument: 'Belgeyi ekle',
    useTemplate: 'Şablonu kullan',
    download: 'İndir',
    attachment: 'Eklenti',
    templateLabel: 'Şablon: {{name}}',
    windowClosed: '24 saatlik süre doldu. Görüşmeyi yeniden açmak için bir şablon gönderin.',
    chooseTemplate: 'Şablonu seç',
  },
  sidebar: {
    title: 'Müşteri dosyası',
    placeholder: 'Müşteri ayrıntılarını görmek için bir görüşme seçin.',
    noCustomer: 'Bu numara bir müşteriye bağlı değil.',
    contact: 'İletişim: {{name}}',
    optIn: "WhatsApp'a katılım onaylandı",
    optInSaved: 'İzin kaydedildi.',
    openDocuments: 'Belgeleri aç',
    noDocuments: 'Açık belge yok.',
    documentsError: 'Belgeler yüklenemedi.',
  },
  templates: {
    pickTitle: 'Şablonu gönder',
    pickDescription:
      'Yalnızca Meta tarafından onaylanan şablonlar 24 saatlik pencerenin dışında teslim edilebilir.',
    template: 'Şablon',
    choose: 'Şablonu seç',
    placeholder: 'Yer tutucu {{position}}',
    preview: 'Önizleme',
    pdfHeader: "PDF'yi başlık olarak belgeleyin",
    send: 'Şablonu gönder',
    sent: 'Şablon gönderildi.',
    error: 'Şablonlar yüklenemedi.',
    emptyApproved: 'Onaylanmış şablon yok.',
  },
  document: {
    title: 'Belgeyi ekle',
    description: 'Belge mevcut konuşmaya PDF olarak gönderilir.',
    document: 'Belge',
    choose: 'Belgeyi seç',
    caption: 'Altyazı',
    captionPlaceholder: 'Ek için isteğe bağlı metin',
    send: 'Belgeyi gönder',
    sent: 'Belge gönderildi.',
    empty: 'Bu müşteriye ait belge yok.',
    error: 'Belgeler yüklenemedi.',
  },
  documentSend: {
    chooseConversation: 'Sohbet seçin',
    action: 'WhatsApp ile gönder',
    title: 'Belgeyi WhatsApp aracılığıyla gönder',
    description: "{{number}} belgesini {{customer}}'ye teslim edin.",
    noConversation: 'Bu müşteri için henüz bir görüşme yok.',
    createChat: 'Konuşma oluştur',
    windowOpenHint: "Hizmet penceresi açık; şablon belgeyi PDF'siyle birlikte sunar.",
    windowClosedHint: 'Hizmet penceresi kapatıldı. Teslimatta onaylanmış bir şablon kullanılır.',
    chooseTemplate: 'Şablonu seç ve gönder',
  },
  customerTab: {
    subtitle:
      'Bu müşterinin kayıtlı WhatsApp sohbetleri. Yalnızca size atanan hesaplar gösterilir.',
    start: 'Yeni görüşme',
    startTitle: 'Bir WhatsApp görüşmesi başlatın',
    startDescription: "Sayı otomatik olarak E.164'e normalleştirilir.",
    started: 'Görüşme oluşturuldu.',
    phone: 'Cep telefonu numarası',
    empty: 'Bu müşteri için henüz bir WhatsApp görüşmesi yok.',
    error: 'Konuşmalar yüklenemedi.',
    noAccess: 'WhatsApp geçmişini görüntüleme izniniz yok.',
  },
  config: {
    title: 'WhatsApp yapılandırması',
    subtitle: 'WhatsApp bağlantılarını ve Cloud şablonlarını yönetin.',
    error: 'Yapılandırma yüklenemedi.',
    tabConnection: 'WhatsApp Business Cloud API',
    tabTemplates: 'Cloud şablonları',
    credentials: "Meta Grafik API'si",
    credentialsHint:
      'Bu değerler Meta geliştirici kontrol panelinden gelir. Sırlar şifrelenmiş olarak saklanır ve asla geri döndürülmez.',
    phoneNumberId: 'Telefon numarası kimliği',
    wabaId: 'WhatsApp işletme hesabı kimliği',
    appId: 'Uygulama Kimliği',
    businessPhoneNumber: 'Gönderen numarası (E.164)',
    displayName: 'Görünen ad',
    accessToken: 'Kalıcı erişim belirteci',
    appSecret: 'Uygulama sırrı',
    secretPlaceholder: 'Yalnızca değeri değiştirmek için doldurun',
    secretSet: 'Depolandı ({{hint}})',
    secretMissing: 'Henüz saklanmadı',
    rotateToken: 'Yeni bir doğrulama jetonu oluştur',
    rotateTokenHint: "Webhook'un Meta kontrol panelinde yeniden kurulmasını gerektirir.",
    saved: 'Yapılandırma kaydedildi.',
    test: 'Bağlantıyı test edin',
    verifiedName: 'Doğrulanmış ad',
    displayNumber: 'Ekran numarası',
    quality: 'Kalite',
    limit: 'Mesajlaşma sınırı',
    checkedAt: "{{timestamp}}'de kontrol edildi",
    webhook: 'Web kancası kurulumu',
    webhookHint:
      'Bu değerleri Meta geliştirici kontrol panelindeki "Web kancaları" altına girin ve "mesajlar" alanına abone olun.',
    callbackUrl: "Geri arama URL'si",
    verifyToken: 'Belirteci doğrula',
    copy: 'Kopyala',
    copied: 'Panoya kopyalandı.',
    lastWebhook: 'Son teslimat: {{timestamp}}',
    noWebhookYet: 'Henüz teslimat alınmadı.',
    templates: "Meta'dan Şablonlar",
    templatesHint: 'Yerel yansıtma her senkronizasyonda tamamen yenilenir.',
    templatesEmpty: 'Henüz hiçbir şablon senkronize edilmedi.',
    sync: 'Senkronizasyon şablonları',
    syncDone: '{{fetched}} şablonları getirildi · {{created}} yeni · {{updated}} güncellendi.',
    templateName: 'Ad',
    language: 'Dil',
    category: 'Kategori',
    status: 'Durum',
    templatePreview: 'ERP yer tutucularıyla önizleme',
  },
  accounts: {
    unavailableMember: 'Artık mevcut olmayan çalışan ({{id}})',
    unavailableHelp:
      'Bu kayıtlı atamalar artık mevcut olmayan çalışanlara aittir. Kaldırılmaları gerekiyorsa açıkça kaldırın. Hiçbir atama otomatik kaldırılmaz.',

    title: 'WhatsApp hesapları',
    description:
      'Her hesabın ayrı bir bağlantısı vardır. Yalnızca atanan çalışanlar hesabın sohbetlerini ve QR kodunu görebilir.',
    select: 'WhatsApp hesabı',
    choose: 'Hesap seçin',
    all: 'Atanan tüm hesaplar',
    empty: 'Size atanmış WhatsApp hesabı yok.',
    error: 'WhatsApp hesapları yüklenemedi.',
    new: 'Hesap ekle',
    edit: 'Hesabı düzenle',
    label: 'Hesap adı',
    members: 'Atanan çalışanlar',
    noMembers: 'Çalışan atanmadan bu hesabı kimse kullanamaz.',
    manageEmpty: 'Henüz WhatsApp hesabı eklenmedi.',
    saved: 'WhatsApp hesabı kaydedildi.',
    saveError: 'Hesap kaydedilemedi. Bilgileri kontrol edip tekrar deneyin.',
    rescan: 'Eşleştirme kaldırıldı. Yeni bir QR kodu tarayın.',
    membersError: 'Çalışanlar yüklenemedi.',
    invalid: 'Hesap adını ve çalışan seçimini kontrol edin.',
  },
  history: {
    connect: 'Bağlan ve geçmişi yükle',
    connectTitle: '{{account}} metin geçmişiyle bağlansın mı?',
    connectDescription:
      'Eşleştirme sırasında mevcut metin geçmişini istemek için ilk QR taramasından önce bu işlemi seçin. Mevcut bir bağlantının oturumu otomatik kapatılmaz.',
    connectConfirm: 'Metin geçmişiyle bağla',
    pairingRequired:
      'Bu bağlantıda başlangıç noktası olarak kullanılabilecek uygun ERP mesajı yok. Hesabın oturumunu bilinçli olarak kapatın ve yeni QR kodunu taramadan önce “Bağlan ve geçmişi yükle” seçeneğini kullanın. Normal yeniden bağlanma bu geçmişi getirmez.',

    action: 'Geçmişi iste',
    title: '{{account}} için geçmiş istensin mi?',
    description:
      'Bağlı cihazdaki mevcut metin mesajlarını ister. Yalnızca bilinen ERP müşterileri ve ilgili kişiler ya da bu hesaba açıkça atanmış sohbetler aktarılır. Eski mesajlar bölümler halinde yüklenir: istek başına en fazla 200 sohbet, sohbet başına 1.000 mesaj ve on dakika. Daha uzun geçmiş için yeniden isteyin. Kullanılabilirliği WhatsApp belirler; tam aktarım garanti edilmez.',
    confirm: 'Geçmişi şimdi iste',
    pending: 'Geçmiş isteniyor …',
    requested:
      'İstek gönderildi. Bilinen ERP kişilerinin kullanılabilir metin mesajlarıı işlendikten sonra görünür.',
    unavailable: 'Bağlı cihaz şu anda geçmiş sunmuyor.',
    error: 'Geçmiş istenemedi. Bağlantıyı kontrol edip tekrar deneyin.',
  },
  phone: {
    change: 'Numarayı değiştir',
    changeTitle: 'WhatsApp numarasını değiştir',
    changeDescription:
      'Yeni numara için seçilen WhatsApp hesabında ayrı bir sohbet oluşturulur. Önceki geçmiş korunur. Müşteri bilgileri otomatik olarak değiştirilmez.',
    useNumber: 'Yeni numarayı kullan',

    existing: 'Mevcut numara',
    choose: 'Müşteri veya kişi numarası seçin',
    invalid: 'Geçerli bir cep telefonu numarası girin; örneğin 0170 1234567 veya +49 170 1234567.',
    loadError: 'Mevcut telefon numaraları yüklenemedi.',
    source: {
      CUSTOMER: 'Müşteri numarası',
      CONTACT_MOBILE: 'Kişi: cep telefonu',
      CONTACT_PHONE: 'Kişi: telefon',
    },
  },
  baileysTemplates: {
    title: 'Yerel WhatsApp şablonları',
    description:
      'Baileys hesapları için yeniden kullanılabilir metinler. Yerel şablonlar Meta onayı gerektirmez ve normal iletişim tercihlerini dikkate alır.',
    create: 'Yerel şablon ekle',
    edit: 'Yerel şablonu düzenle',
    delete: 'Yerel şablonu sil',
    confirmDeleteTitle: '{{name}} silinsin mi?',
    confirmDeleteDescription:
      'Bu yerel şablon yeni mesajlar için artık kullanılamayacak. Mevcut mesajlar korunur.',
    empty: 'Henüz yerel şablon eklenmedi.',
    loadError: 'Yerel şablonlar yüklenemedi.',
    name: 'Şablon adı',
    language: 'Dil',
    body: 'Mesaj metni',
    bodyHelp:
      '{{example}} gibi numaralı yer tutucular kullanın. 1 ile başlayın ve numara atlamayın; en fazla 50 farklı yer tutucu ve 4.096 karakter.',
    variableMapping: 'İsteğe bağlı ERP değerleri',
    mappingSource: 'Değer kaynağı {{position}}',
    mappingLabel: 'Alan etiketi {{position}}',
    noMapping: 'Elle girin',
    transactionalOnly:
      'İşlemsel mesajlar içindir. Reklam iletişimi, belgelenmiş izne dayanan ayrı pazarlama sürecini gerektirir.',
    saved: 'Yerel şablon kaydedildi.',
    deleted: 'Yerel şablon silindi.',
    versionConflict:
      'Bu şablon başka biri tarafından değiştirildi. Kaydetmeden veya göndermeden önce yeniden yükleyin.',
    duplicateName: 'Bu ad ve dilde bir yerel şablon zaten mevcut.',
    invalidPlaceholders:
      '{{example}} gibi yalnızca 1 ile 50 arasında, numara atlamayan yer tutucular kullanın.',
    invalidMapping: 'Her ERP değerini yalnızca bir kez ve mevcut bir yer tutucuya atayın.',
    invalidParameters:
      'Her yer tutucuyu tam bir kez geçerli bir değerle doldurun. Mesaj uzunluğunu kontrol edin.',
    invalidName: 'En fazla 120 karakterlik bir şablon adı girin.',
    invalidLanguage: 'Desteklenen bir dil seçin.',
    invalidBody: 'En fazla 4.096 karakterlik bir mesaj girin.',
    validationSummary: 'Şablon kaydedilemedi. İşaretlenen alanları kontrol edin.',
    discardTitle: 'Değişiklikler atılsın mı?',
    discardDescription: 'Bu şablonda kaydedilmemiş değişiklikler kaybolacak.',
    discard: 'Değişiklikleri at',
    pickTitle: 'Yerel WhatsApp şablonu gönder',
    pickDescription:
      'Seçilen Baileys hesabından göndermeden önce metni ve tüm değerleri kontrol edin.',
    choose: 'Yerel şablon seçin',
    send: 'Mesaj gönder',
    preview: 'Mesaj önizlemesi',
    pdfAttachment: 'PDF eklendi',
    search: 'Yerel şablonlarda ara',
    page: 'Sayfa {{page}} / {{pages}}',
    captionTooLong: 'PDF ile gönderilen bir mesaj en fazla 1.024 karakter içerebilir.',
    sources: {
      'customer.name': 'Müşteri adı',
      'customer.number': 'Müşteri numarası',
      'contact.firstName': 'İlgili kişinin adı',
      'document.number': 'Belge numarası',
      'document.date': 'Belge tarihi',
      'document.dueDate': 'Vade tarihi',
      'document.grossTotal': 'Brüt tutar',
      'document.currency': 'Para birimi',
      'tenant.name': 'Şirket adı',
      'user.name': 'Çalışan adı',
      custom: 'Elle girilen değer',
    },
  },
};
